/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ContentWatchSettings'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ContentWatchSettings'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ContentWatchSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ContentWatchSettings);
  }
}(this, function(ApiClient, ContentWatchSettings) {
  'use strict';

  /**
   * ContentWatchSettings service.
   * @module api/ContentWatchSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ContentWatchSettingsApi. 
   * @alias module:api/ContentWatchSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the contentWatchSettingsAddPut operation.
     * @callback module:api/ContentWatchSettingsApi~contentWatchSettingsAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ContentWatchSettings} body 
     * @param {module:api/ContentWatchSettingsApi~contentWatchSettingsAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.contentWatchSettingsAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling contentWatchSettingsAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling contentWatchSettingsAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/ContentWatchSettings/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contentWatchSettingsDeletePut operation.
     * @callback module:api/ContentWatchSettingsApi~contentWatchSettingsDeletePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {module:model/ContentWatchSettings} body 
     * @param {module:api/ContentWatchSettingsApi~contentWatchSettingsDeletePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.contentWatchSettingsDeletePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling contentWatchSettingsDeletePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling contentWatchSettingsDeletePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ContentWatchSettings/delete', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contentWatchSettingsEditPut operation.
     * @callback module:api/ContentWatchSettingsApi~contentWatchSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ContentWatchSettings} body 
     * @param {module:api/ContentWatchSettingsApi~contentWatchSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.contentWatchSettingsEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling contentWatchSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling contentWatchSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ContentWatchSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contentWatchSettingsLoadAllGet operation.
     * @callback module:api/ContentWatchSettingsApi~contentWatchSettingsLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ContentWatchSettings>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/ContentWatchSettingsApi~contentWatchSettingsLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ContentWatchSettings>}
     */
    this.contentWatchSettingsLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling contentWatchSettingsLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ContentWatchSettings];

      return this.apiClient.callApi(
        '/ContentWatchSettings/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the contentWatchSettingsLoadGet operation.
     * @callback module:api/ContentWatchSettingsApi~contentWatchSettingsLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContentWatchSettings} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} typeID 
     * @param {Integer} settingsID 
     * @param {module:api/ContentWatchSettingsApi~contentWatchSettingsLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContentWatchSettings}
     */
    this.contentWatchSettingsLoadGet = function(_4SAPIAppID, typeID, settingsID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling contentWatchSettingsLoadGet";
      }

      // verify the required parameter 'typeID' is set
      if (typeID == undefined || typeID == null) {
        throw "Missing the required parameter 'typeID' when calling contentWatchSettingsLoadGet";
      }

      // verify the required parameter 'settingsID' is set
      if (settingsID == undefined || settingsID == null) {
        throw "Missing the required parameter 'settingsID' when calling contentWatchSettingsLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'typeID': typeID,
        'settingsID': settingsID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ContentWatchSettings;

      return this.apiClient.callApi(
        '/ContentWatchSettings/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
